import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa'
import { Button, Tooltip } from '@outbound-ai/ursa'
import styled, { useTheme } from 'styled-components'
import { PositionEnum } from 'types/cssTypes'

interface IProps {
  isMutedAudio: boolean
  toggleIsMuted: () => void
}

export const MuteUnmuteAudio = ({ isMutedAudio, toggleIsMuted }: IProps) => {
  const theme = useTheme()
  const handleClick = () => toggleIsMuted()

  return (
    <Span>
      <Tooltip
        tooltipText={isMutedAudio ? `Turn on Call Audio (muted)` : `Silence Call Audio`}
        position={PositionEnum.top}
        positionContent={100}
        positionTooltipArrow={15}
        tooltipStyles={{ 'min-width': isMutedAudio ? '12rem' : '8rem', transform: 'translateX(-30%)' }}
      >
        <Button className="audio-btn" contentType="icon-only" radius="rounded" onClick={handleClick}>
          {isMutedAudio ? (
            <FaVolumeMute color={theme.colors.error.darker} />
          ) : (
            <FaVolumeUp color={theme.colors.success.darker} />
          )}
        </Button>
      </Tooltip>
    </Span>
  )
}

const Span = styled.span`
  .audio-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ theme }) => theme.util.pixelToRem(45)};
    height: ${({ theme }) => theme.util.pixelToRem(45)};
    border: 1px solid ${({ theme }) => theme.colors.grey.lighter};
    border-radius: 0.75rem;
    padding: ${({ theme }) => `${theme.spacing.s} ${theme.spacing.xs}`};
    background-color: ${({ theme }) => theme.colors.grey.lightest};

    svg {
      width: ${({ theme }) => theme.spacing.m};
      height: ${({ theme }) => theme.spacing.s};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.grey.lighter};
      cursor: pointer;
    }

    &:focus {
      box-shadow: none;
    }
  }
`
